export default [
    {
        path: 'relatorio-cuidado-pessoa-com-diabete',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-pessoa-com-diabete' */
            '@/views/atencao-basica/relatorio-cuidado-pessoa-com-diabete/Index'
        ),
        redirect: 'relatorio-cuidado-pessoa-com-diabete/index',
        children: [
            {
                name: 'atencao-basica-relatorio-cuidado-pessoa-com-diabete-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cuidado-pessoa-com-diabete' */
                    '@/views/atencao-basica/relatorio-cuidado-pessoa-com-diabete/List.vue'
                ),
            },
        ],
    },
]